import { Domains } from '@dtx-company/true-common/src/types/domains'
import { FRONTEGG_FB_AUTH } from '@dtx-company/true-common/src/constants/featureFlags'
import { POPUP_CLOSED_BY_USER } from '@dtx-company/true-common/src/constants/sso'
import { SocialAuthProps } from '@dtx-company/app/shared/code/src/components/molecules/social-auth/index.types'
import { SocialProvider } from '@dtx-company/true-common/src/types/socialProvider'
import { sendErrorNotification } from '../../../utils/notifications'
import { signInWithFacebook } from '@dtx-company/ithaca-sdk/src'
import { useFacebookLoginUrl } from '@dtx-company/app/shared/common/src/hooks/useSocialLoginUrl'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'

export function useSocialAuthState({ onClick }: Pick<SocialAuthProps, 'onClick'>): {
  handleClick: (provider: SocialProvider, product?: Domains) => Promise<void>
} {
  const { url: facebookLoginUrl } = useFacebookLoginUrl('login')
  const [useFronteggFBAuth] = useFlowFeature(FRONTEGG_FB_AUTH, { autoUpdate: true })

  const handleClick = async (
    provider: SocialProvider,
    product = Domains.FLOWCODE
  ): Promise<void> => {
    try {
      if (provider === SocialProvider.FACEBOOK) {
        if (useFronteggFBAuth) {
          if (!facebookLoginUrl) {
            sendErrorNotification('Something went wrong connecting to Facebook, please try again.')
            return
          }
          window.location.href = facebookLoginUrl
        } else {
          const user = await signInWithFacebook(product)
          onClick(user, provider)
        }
      }
    } catch (e) {
      console.error('error signing in with social account', e.message)
      if (e.code !== POPUP_CLOSED_BY_USER) {
        sendErrorNotification(e.message)
      }
    }
  }
  return {
    handleClick
  }
}
